<template>
    <Wrapper>
        <Breadcrumb :items="breadcrumbItems" />

        <div class="grid grid-cols-12 base-responsive-gap mt-6">
            <div class="col-span-12">
                <h1 class="header-1 mb-4"><T t="career.title" /></h1>
                <div>
                    <p><T t="career.description_1" /></p>
                    <br />
                    <p><T t="career.description_2" /></p>
                </div>

                <div class="mt-14 sm:mt-20">
                    <div v-if="positions.length">
                        <div
                            v-for="(item, i) in positions"
                            :key="item.id"
                            class="flex flex-col sm:flex-row justify-between items-start sm:items-center"
                            :class="{ 'border-t border-black pb-4 pt-8 mt-8': i > 0 }"
                        >
                            <div class="mb-4 sm:mb-0">
                                <NuxtLink
                                    :to="
                                        localePath({
                                            name: 'career-position',
                                            params: { position: item.slug },
                                        })
                                    "
                                    class="lg-lead sm:mr-4"
                                >
                                    {{ item.name }}
                                </NuxtLink>
                                <div v-if="item.lead" class="mt-2" v-html="item.lead"></div>
                            </div>
                            <div class="min-w-[9rem] text-right">
                                <Button
                                    :to="
                                        localePath({
                                            name: 'career-position',
                                            params: { position: item.slug },
                                        })
                                    "
                                    :label="$t('career.result_card_button_text')"
                                />
                            </div>
                        </div>
                    </div>

                    <div v-else class="md-lead"><T t="career.no_results_text" /></div>
                </div>

                <div class="flex flex-wrap mt-12 sm:mt-24 justify-center sm:justify-start">
                    <img v-for="(badge, i) in badges" :key="`badge-${i}`" class="h-44 mr-2 mb-8" :src="badge.src" />
                </div>
            </div>
        </div>
    </Wrapper>
</template>

<script>
import Wrapper from '@/components/Pages/Docs/Wrapper.vue';

export default {
    name: 'Index',
    components: {
        Wrapper,
    },
    async asyncData({ $axios, i18n }) {
        let positions = [];
        let badges = [];

        await Promise.allSettled([$axios.$get('/careers'), $axios.$get('/galleries/reference/career___badgdes')])
            .then(([modelRes, badgesRes]) => {
                if (modelRes.status === 'fulfilled') {
                    positions = modelRes.value.data;
                }

                if (badgesRes.status === 'fulfilled') {
                    console.log(badgesRes);
                    badges = badgesRes.value.slides;
                }
            })
            .catch((err) => {
                console.log(err);
            });

        const breadcrumbItems = [];

        breadcrumbItems.push([i18n.t('career.title'), 'career']);

        return {
            positions,
            badges,
            breadcrumbItems,
        };
    },
    head() {
        return {
            title: this.$getPageTitle('career.index'),
            meta: this.$getPageMetaData('career.index'),
        };
    },
};
</script>

<style scoped></style>
